import * as React from 'react';
import { AScene } from '@eagerlogic/react-mvc';
import { RegisterModel } from './model/RegisterModel';
import { RegisterController } from './controller/RegisterController';
import { ISceneFactory } from 'scenes/ISceneFactory';
import { HistoryItem, Navigation } from 'utils/Navigation';
import { AuthCard } from '../AuthCard';
import { TextField } from 'components/input/TextField';
import { SimpleSelect, SelectItem } from 'components/input/SimpleSelect';
import { Button } from '@material-ui/core';

export class RegisterScene extends AScene<Props, RegisterModel, RegisterController> {

    private companyName: string = "";
    private userName: string = "";
    private email: string = "";
    private password: string = "";
    private timeZone: string = "";

    public constructor(props: Props) {
        super(props);

        this.handleRegisterClicked = this.handleRegisterClicked.bind(this);
        this.handleCancelClicked = this.handleCancelClicked.bind(this);
    }

    protected createControlller(): RegisterController {
        return new RegisterController();
    }

    private handleRegisterClicked() {
        this.controller.onRegisterClicked(this.companyName, this.userName, this.email, this.password, this.timeZone);
    }

    private handleCancelClicked() {
        this.controller.onCancelClicked();
    }

    public render(): React.ReactNode {
        if (this.model.isInit) {
            return (<></>);
        }

        this.companyName = this.model.companyName;
        this.userName = this.model.userName;
        this.email = this.model.email;
        this.password = this.model.password;
        this.timeZone = this.model.timeZone;

        return (
            <AuthCard title="Register" error={this.model.error}>
                <TextField label="Company name" value={this.model.companyName} error={this.model.companyNameError} onChange={(v) => { this.companyName = v; }} />
                <TextField label="Your name" value={this.model.userName} error={this.model.userNameError} onChange={(v) => { this.userName = v; }} />
                <TextField label="Email" value={this.model.email} error={this.model.emailError} onChange={(v) => { this.email = v; }} />
                <TextField label="Password" type="password" value={this.model.password} error={this.model.passwordError} onChange={(v) => { this.password = v; }} />
                <SimpleSelect label="Time zone" defaultValue={this.model.timeZone} onChange={(v) => { this.timeZone = v; }}>
                    {this.model.timezoneItems.map((tz) => (<SelectItem key={"tz-" + tz.id} value={tz.id} title={tz.label} />))}
                </SimpleSelect>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', marginTop: '8px' }}>
                    <Button color="secondary" onClick={this.handleCancelClicked}>Cancel</Button>
                    <Button style={{ marginLeft: '8px' }} color="primary" variant="contained" onClick={this.handleRegisterClicked}>Sign up</Button>
                </div>
                <div style={{ textAlign: 'center', marginTop: '24px', fontSize: '14px', color: '#888' }}>
                    Already have an account?{' '}
                    <a href="/login.rsc" style={{ color: '#009155' }} onClick={(e) => { e.preventDefault(); Navigation.pushState(null, "/login.rsc"); }}>Login</a>
                </div>
            </AuthCard>
        );
    }

}

export class Props {

}

export class RegisterSceneFactory implements ISceneFactory {

    create(historyItem: HistoryItem): React.ReactNode {
        return (
            <RegisterScene />
        );
    }

}
